import { createSlice } from "@reduxjs/toolkit";
import editUrgencyApi from "@custom/rtk-apis/billing/urgency/editUrgency";

const initialState = {
  status:"",
  result:null,
  msg:"",
  loading:false,
  error:""
};

const editUrgencySlice = createSlice({
  name: "editUrgencySlice",
  initialState,
  reducers: {
    clearEditUrgency (state:any) { state.status = ""; }
  },
  extraReducers: (builder) => {
    builder
      .addCase(editUrgencyApi.pending, (state, action) => {
        state.loading = true;
      })
      .addCase(editUrgencyApi.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload.status;
        state.result = payload.result;
        state.msg = payload.msg;
      })
      .addCase(editUrgencyApi.rejected, (state, { payload }) => {
        state.result = payload;
        state.loading = false;
      });
  },
});

export default editUrgencySlice.reducer;
export const { clearEditUrgency } = editUrgencySlice.actions;
